import React, { useState } from 'react';
import ArrowRight from '../../../../assets/images/account-page/arrowRight.svg';
// import { useHandleError } from '../../../../services/api';
import { useIntl } from 'react-intl';
import messages from '../messages';
import moment from 'moment';

const LoungeAccessTrip = (props: any) => {
  const [open, setOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { flight } = props;
  // const [handleError] = useHandleError();
  const date = moment(flight.flight_date).format('DD/MM/YYYY');

  // const handleDownloadQR = () => {
  //   const qrCode = flight?.qr_code;

  //   try {
  //     // First check if we have a QR code
  //     if (!qrCode) {
  //       throw new Error('No QR code available');
  //     }

  //     // Create download link
  //     const link = document.createElement('a');
  //     link.href = qrCode; // The QR code is already a data URL
  //     link.download = `lounge-access-${flight?.departureAirport?.iata}-${flight?.arrivalAirport?.iata}.png`;

  //     // Trigger download
  //     document.body.appendChild(link);
  //     link.click();

  //     // Cleanup
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  const handleShowQRCode = () => {
    setOpen(!open);
  };

  return (
    <div className="container-lounge flex flex-col" style={{ gap: '8px' }}>
      <div className="container-lounge-header flex justify-between flex-col md:flex-row items-center">
        <div className="flex" style={{ gap: '8px' }}>
          <div className="flex items-center">
            <span className="lounge-iata">
              {flight?.departureAirport?.iata}
            </span>
            <img src={ArrowRight} alt="" width={15} height={15} />
            <span className="lounge-iata">{flight?.arrivalAirport?.iata}</span>
            <div style={verticalLineStyles} />
            <span className="lounge-text-styles">
              {formatMessage(messages.loungeAccesDate, { date })}
            </span>
          </div>
        </div>
        <div className="lounge-button-container">
          <button className="lounge-button" onClick={handleShowQRCode}>
            {!open
              ? formatMessage(messages.loungeAccessShowButton)
              : formatMessage(messages.loungeAccessHideButton)}
          </button>
        </div>
      </div>
      {open && (
        <div className="flex flex-col" style={{ padding: '10px 24px' }}>
          <div style={{ width: '350px', height: 'auto', margin: '0 auto' }}>
            <img src={flight?.qr_code} />
          </div>

          {/* Lounge Directions */}
          {/* <div className="items-start">
            <span style={{ textDecoration: 'underline' }}>
              {formatMessage(messages.availableLounges)}
            </span>
            <br />
            {flight?.lounges?.map((lounge: any) => (
              <>
                <span>
                  <b>
                    {lounge?.lounge_name} - {lounge?.terminal}:{' '}
                  </b>
                </span>
                <br />
                <span>
                  {formatMessage(messages.openingHours)}:{' '}
                  {lounge?.opening_hours}
                </span>
                <br />
                <span>{lounge?.location}</span>
                <br />
              </>
            ))}
          </div> */}
        </div>
      )}
    </div>
  );
};

export default LoungeAccessTrip;

const verticalLineStyles = {
  borderLeft: '1px solid black',
  height: '20px',
  marginLeft: '5px',
  marginRight: '5px',
};
